var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[(_vm.error)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e(),_c('div',{staticClass:"col-12"},_vm._l((_vm.dataForDisplay),function(field){return _c('base-attr-display-text',{key:field.key,attrs:{"label":field.label}},[_vm._v(" "+_vm._s(field.value)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }